import React from 'react';
import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { useLanguage } from '../context/LanguageContext';

// Active owners first, then previous owners (most recent first).
export const sortOwners = (rows) => [...(rows || [])].sort((a, b) => {
  const aa = a.status === 'active' ? 0 : 1;
  const bb = b.status === 'active' ? 0 : 1;
  if (aa !== bb) return aa - bb;
  return String(b.start_date || '').localeCompare(String(a.start_date || ''));
});

export const defaultOwnerId = (rows) => {
  const active = (rows || []).filter((o) => o.status === 'active');
  return active.length === 1 ? active[0].owner_history_id : '';
};

export const OwnerSelect = ({ owners, value, onChange, testid = 'payment-owner-select', allowAll = true, hint }) => {
  const { t, language } = useLanguage();
  const el = language === 'el';
  return (
    <div data-testid="owner-selector-section">
      <Label className="text-sm font-medium text-zinc-700">{t('selectOwner') || 'Select Owner'}</Label>
      <Select value={value || '__all'} onValueChange={(v) => onChange(v === '__all' ? '' : v)}>
        <SelectTrigger className="mt-1 rounded-none" data-testid={testid}><SelectValue /></SelectTrigger>
        <SelectContent className="rounded-none">
          {allowAll && <SelectItem value="__all">{el ? 'Όλοι οι ιδιοκτήτες (χωρίς σύνδεση)' : 'All owners (not linked)'}</SelectItem>}
          {sortOwners(owners).map((o) => {
            const active = o.status === 'active';
            const name = `${o.first_name || ''} ${o.last_name || ''}`.trim() || '—';
            return (
              <SelectItem key={o.owner_history_id} value={o.owner_history_id} data-testid={`owner-option-${o.owner_history_id}`}>
                <span className="flex items-center gap-2">
                  <span>{name}</span>
                  <span className={`text-[10px] uppercase tracking-wider px-1 ${active ? 'bg-emerald-100 text-emerald-800' : 'bg-zinc-100 text-zinc-500'}`}>
                    {active ? (el ? 'Ενεργός' : 'Active') : (el ? 'Ανενεργός / Προηγούμενος' : 'Inactive / Previous')}
                  </span>
                  {(o.start_date || o.end_date) && <span className="text-[10px] text-zinc-400">{(o.start_date || '').slice(0, 10)} → {(o.end_date || '').slice(0, 10) || (el ? 'σήμερα' : 'today')}</span>}
                </span>
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
      {hint && <p className="text-[11px] text-zinc-500 mt-1">{hint}</p>}
    </div>
  );
};

export default OwnerSelect;
